.k9{min-width:14rem;}